import React, { useState } from 'react';
import { DataManager } from '../../services/dataManager';
import VoiceDictationButton from '../common/VoiceDictationButton';

const ManualEntryModal = ({ clientId, onClose, onSave }) => {
    const [type, setType] = useState('diary'); // 'diary', 'dream', 'journal'
    const [content, setContent] = useState('');
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);

    // For dreams
    const [dreamTitle, setDreamTitle] = useState('');

    const isDream = type === 'dream';

    const handleSave = async () => {
        if (!content.trim()) return;

        try {
            let entryContent = content;
            if (isDream) {
                entryContent = {
                    title: dreamTitle || 'Sogno senza titolo',
                    text: content,
                    category: 'Sogni',
                    emotions: [], // Could add emotion picker later
                    userTags: []
                };
            }

            await DataManager.saveWork({
                clientId,
                type: type, // 'diary' | 'dream' | 'journal'
                content: entryContent,
                shared: true, // Manual entries by counselor are implicitly shared/visible
                timestamp: new Date(date).toISOString()
            });

            onSave();
            onClose();
        } catch (error) {
            console.error("Error saving manual entry:", error);
            alert("Errore nel salvataggio");
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg border border-gray-100 overflow-hidden animate-fade-in">
                <div className="bg-amber-50 p-6 border-b border-amber-100">
                    <h2 className="text-xl font-bold text-amber-900 flex items-center gap-2">
                        <span>✍️</span> Inserimento Manuale Diario
                    </h2>
                    <p className="text-amber-700/80 text-sm mt-1">
                        Aggiungi una voce per conto del cliente (Modalità Manuale)
                    </p>
                </div>

                <div className="p-6 space-y-4">
                    {/* Date & Type */}
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Data</label>
                            <input
                                type="date"
                                className="w-full p-2 border rounded-xl text-sm"
                                value={date}
                                onChange={e => setDate(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Tipo Voce</label>
                            <select
                                className="w-full p-2 border rounded-xl text-sm bg-white"
                                value={type}
                                onChange={e => setType(e.target.value)}
                            >
                                <option value="diary">📔 Diario</option>
                                <option value="dream">🌙 Sogno</option>
                                <option value="journal">✍️ Journaling</option>
                            </select>
                        </div>
                    </div>

                    {/* Dream Title (Conditional) */}
                    {isDream && (
                        <div>
                            <label className="block text-xs font-bold text-gray-500 mb-1">Titolo Sogno</label>
                            <input
                                type="text"
                                className="w-full p-3 border rounded-xl text-sm placeholder-gray-400"
                                placeholder="Es: Volare sopra la città"
                                value={dreamTitle}
                                onChange={e => setDreamTitle(e.target.value)}
                            />
                        </div>
                    )}

                    {/* Content Area */}
                    <div>
                        <div className="flex justify-between items-center mb-1">
                            <label className="block text-xs font-bold text-gray-500">
                                {isDream ? 'Racconto del sogno' : 'Contenuto'}
                            </label>
                            <VoiceDictationButton
                                label="Detta testo"
                                currentValue={content}
                                onTranscript={(updater) => {
                                    setContent(prev => typeof updater === 'function' ? updater(prev) : updater);
                                }}
                            />
                        </div>
                        <textarea
                            className="w-full p-4 border rounded-2xl h-40 resize-none focus:ring-2 focus:ring-amber-200 outline-none"
                            placeholder={isDream ? "Descrivi il sogno..." : "Scrivi qui..."}
                            value={content}
                            onChange={e => setContent(e.target.value)}
                        ></textarea>
                    </div>
                </div>

                <div className="bg-gray-50 p-4 flex justify-end gap-3 border-t border-gray-100">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-600 font-medium hover:bg-gray-200 rounded-xl transition"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={!content.trim()}
                        className="px-6 py-2 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl shadow-md transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Salva Voce
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ManualEntryModal;
